import { customNavigation } from "../../widgets/custom-navigation/assets/widget";
import { homeHero } from "../../widgets/home-hero/assets/widget";
import { customFooter } from "../../widgets/custom-footer/assets/widget";
import { councillorCarousel } from "../../widgets/councillor-carousel/assets/widget";

// ------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() { 

    // ! Call all of the widget scripts here.
    customNavigation();
    homeHero();
    councillorCarousel();
    customFooter();

});
